/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

export default function HierarchyVertical({ width, height }) {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.3562 9.72806H13.4228V9.14548C13.4228 8.22934 12.6773 7.48349 11.7608 7.48349L8.71732 7.48349L8.71732 6.27194L9.83121 6.27194C10.4625 6.27194 10.9813 5.75955 10.9813 5.12814V1.90945C10.9813 1.27805 10.4625 0.765656 9.83121 0.765656L6.34991 0.765656C5.71866 0.765656 5.20619 1.27805 5.20619 1.90945L5.20619 5.12814C5.20619 5.75955 5.71866 6.27194 6.34991 6.27194H7.46732V7.48349H4.42349C3.50735 7.48349 2.76181 8.22934 2.76181 9.14548V9.72806H1.64372C1.01247 9.72806 0.5 10.2408 0.5 10.8719L0.5 14.0905C0.5 14.722 1.01247 15.2343 1.64372 15.2343H5.12494C5.7562 15.2343 6.27499 14.722 6.27499 14.0905V10.8719C6.27499 10.2408 5.7562 9.72806 5.12494 9.72806H4.01181V9.14548C4.01181 8.91843 4.19644 8.73349 4.42349 8.73349H8.09232L11.7608 8.73349C11.9879 8.73349 12.1728 8.91843 12.1728 9.14548V9.72806H10.8749C10.2437 9.72806 9.73126 10.2408 9.73126 10.8719V14.0905C9.73126 14.722 10.2437 15.2343 10.8749 15.2343H14.3562C14.9875 15.2343 15.5 14.722 15.5 14.0905V10.8719C15.5 10.2408 14.9875 9.72806 14.3562 9.72806Z" fill="white"/>
    </svg>
  );
}

HierarchyVertical.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

HierarchyVertical.defaultProps = {
  width: 16,
  height: 16,
};
